import type { FC, JSX } from 'react';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useFormatting } from '@pflegenavi/frontend/localization';

interface BalanceSagesCardProps {
  balance: number;
  topUpAmount: number;
  disabled: boolean;
  pendingChargesAmount: number;
}

export const BalanceSagesCard: FC<BalanceSagesCardProps> = ({
  balance,
  topUpAmount,
  disabled,
  pendingChargesAmount,
}): JSX.Element => {
  const { t } = useTranslation();
  const { fCurrencyCents } = useFormatting();

  const newBalance = balance + pendingChargesAmount + topUpAmount;

  return (
    <Stack
      sx={{
        justifyContent: 'space-between',
        p: 1.5,
        bgcolor: disabled ? 'grey.600' : 'primary.main',
        borderRadius: 2,
        flex: 1,
        width: 1,
      }}
    >
      <Stack
        direction="row"
        sx={{
          justifyContent: 'space-between',
        }}
      >
        <Typography
          sx={{
            fontSize: 16,
            color: 'white',
          }}
        >
          {t('mobile.family-member.current-balance')}:
        </Typography>
        <Typography
          sx={{
            fontSize: 16,
            color: 'white',
          }}
        >
          {fCurrencyCents(balance)}
        </Typography>
      </Stack>
      {pendingChargesAmount > 0 && (
        <Stack
          direction="row"
          sx={{
            justifyContent: 'space-between',
          }}
        >
          <Typography
            sx={{
              fontSize: 16,
              color: 'white',
            }}
          >
            {t('mobile.family-member.current-payments')}:
          </Typography>
          <Typography
            sx={{
              fontSize: 16,
              color: 'success.main',
            }}
          >
            +{fCurrencyCents(pendingChargesAmount)}
          </Typography>
        </Stack>
      )}
      <Stack
        direction="row"
        sx={{
          justifyContent: 'space-between',
        }}
      >
        <Typography
          sx={{
            fontSize: 16,
            color: 'white',
          }}
        >
          {t('fm-triggered-payments.amount-screen.top-up-amount')}:
        </Typography>
        <Typography
          sx={{
            fontSize: 16,
            color: 'success.main',
          }}
        >
          +{fCurrencyCents(topUpAmount)}
        </Typography>
      </Stack>
      <Stack
        direction="row"
        sx={{
          justifyContent: 'space-between',
        }}
      >
        <Typography
          sx={{
            fontSize: 16,
            color: 'white',
          }}
        >
          {t('fm-triggered-payments.amount-screen.new-balance')}:
        </Typography>
        <Typography
          sx={{
            fontSize: 16,
            color: 'white',
          }}
        >
          {fCurrencyCents(newBalance)}
        </Typography>
      </Stack>
    </Stack>
  );
};
